/**
 * Module Staff #12 — Documentation interne & messagerie
 */
const moduleStaffDocInt = {
  id: 'staff-documentation',
  population: 'staff',
  order: 12,
  category: 'Support',
  title: 'Documentation interne & messagerie',
  subtitle: 'Communication interne efficace + base de connaissance',
  icon: 'BookOpen',
  duration: '15 min',
  level: 'Débutant',
  slides: [
    { type: 'cover', eyebrow: 'Module 12 — Staff', title: 'Documentation interne', subtitle: 'Messagerie, FAQ, ressources', icon: 'BookOpen', duration: '15 min', audience: 'Tout staff', level: 'Débutant' },
    { type: 'intro', title: 'Objectifs', intro: 'Bien communiquer en interne et exploiter la base de connaissance Baobab.', objectives: [
      'Utiliser la messagerie interne par opération',
      'Accéder à la FAQ et aux guides',
      'Créer un ticket de support technique',
      'Partager une procédure avec collègues',
      'Reconnaître les bons canaux de communication',
    ]},
    { type: 'concept', eyebrow: 'Canaux', icon: 'BookOpen', title: 'Les 4 canaux de communication',
      bullets: [
        '💬 Messagerie par opération : échanges client + équipe (visible à tous)',
        '🔒 Chat interne : staff uniquement, conversations privées équipe',
        '🎫 Tickets support : remontée de bugs ou demandes IT',
        '📚 Wiki / Guides : documentation officielle versionnée',
      ],
      note: 'Pour les sujets sensibles (sécurité, RH), utilisez le chat interne (jamais la messagerie opération).',
    },
    { type: 'steps', title: 'Créer un ticket support', steps: [
      { title: 'Menu Help → Support technique', detail: 'Accessible partout via le bouton "?".' },
      { title: 'Décrire le problème', detail: 'Captures d\'écran + URL + étapes de reproduction.' },
      { title: 'Choisir la priorité', detail: 'Bloquant / Majeur / Mineur / Question.' },
      { title: 'Soumettre', detail: 'L\'équipe IT reçoit notification + SLA selon priorité.' },
    ]},
    { type: 'comparison', title: 'Bonnes pratiques communication', do: [
      'Messagerie opération = traçabilité client',
      'Chat interne = discussions équipe',
      'Tickets = problèmes techniques',
      'Wiki = procédures officielles',
    ], dont: [
      'Pas de sujets sensibles dans la messagerie opération',
      'Pas de bug en messagerie (créer ticket)',
      'Pas de modif procédure sans validation manager',
      'Pas de partage info confidentielle par chat',
    ]},
    { type: 'quiz', title: 'Quiz',
      question: 'Vous trouvez un bug bloquant en finance. Que faire ?',
      options: [
        'Le poster en messagerie opération',
        'Créer un ticket support priorité "Bloquant" avec captures et URL',
        'Appeler la DSI',
        'Attendre que ça passe',
      ],
      answerIndex: 1,
      explanation: 'Ticket = traçabilité + SLA. Le ticket bloquant déclenche une intervention sous 1 h ouvrée.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      '4 canaux : opération / interne / ticket / wiki.',
      'Sujet sensible → jamais en messagerie opération.',
      'Bug technique → ticket avec priorité.',
      'Wiki = source officielle.',
    ]},
    { type: 'cta', title: 'Module 12 terminé !', actions: [
      { label: 'Catalogue', href: '/docs/admin/training' },
    ]},
  ],
};
export default moduleStaffDocInt;
